/**
 * Compact form of a task identifier for dense rows.
 *
 * Project keys derived from long names ("PLAYPASS-AUTOMATIZARI-TERENURI-SPORTIVE-001")
 * pushed the title off the row, so anything longer than a short key keeps the
 * first letters and the number and elides the middle: "PLAY…-001". Short keys
 * ("AIWS-062", "BONDSHUB-001") stay as they are. Show the full identifier as
 * the tooltip / accessibility label wherever this is used.
 */
export const IDENTIFIER_FULL_MAX = 12;
const HEAD_CHARS = 4;

export function shortIdentifier(identifier: string): string {
  if (identifier.length <= IDENTIFIER_FULL_MAX) return identifier;
  const cut = identifier.lastIndexOf('-');
  if (cut <= 0) return identifier;
  const prefix = identifier.slice(0, cut);
  const number = identifier.slice(cut + 1);
  const firstSegment = prefix.split('-')[0] ?? prefix;
  const head = firstSegment.slice(0, HEAD_CHARS);
  if (head.length === prefix.length) return identifier;
  return `${head}…-${number}`;
}
